"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
// TODO: this is a REALLY difficult component to reuse due to the styles, should consider this a specialization of a simpler component
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        button: function (_a) {
            var isPlusIconButton = _a.isPlusIconButton, isError = _a.isError;
            return isPlusIconButton
                ? {
                    textAlign: 'center',
                    fontSize: '16px',
                    width: '150px',
                    height: '150px',
                    flexGrow: 0,
                    margin: '0 15px 0 0',
                    padding: '31px 43px 31px 42px',
                    borderRadius: '10px',
                    border: "dashed 2px ".concat(isError ? theme.palette.error.main : themes_1.materialColors.blue[200]),
                }
                : {
                    border: "solid 1px ".concat(isError ? theme.palette.error.main : themes_1.materialColors.blue[500]),
                    borderRadius: '1000px',
                    color: "".concat(themes_1.materialColors.blue[500]),
                    fontWeight: 600,
                };
        },
        errorText: {
            color: theme.palette.error.main,
        }
    });
});
